import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    curFileName: "xiaodi_test.3dm",
    dataModel: null,
    layers: null,
    //生成状态,控制图层面板和分析面板
    generateStatus: false,
    //去生成，去生成为true，生成完为false
    goGeneration: false,
    //非标户型显示状态
    type1Status: false,
    //非标户型显示状态
    type2Status: false,
    //非标户型显示状态
    noStandStatus: false,

    sumStatics: null,
    //公寓构件中心点
    constructsCenter: null
  },
  mutations: {
    //上传文件的名字
    GETFILENAME(state, fileName) {
      state.curFileName = fileName;
    },
    // DataModel更新
    GETDATAMODEL(state, dataModel) {
      state.dataModel = dataModel;
    },
    // 获取图层名称
    GETFILELAYER(state, layers) {
      state.layers = layers;
    },
    //改变图层&方案分析的可用性
    CHANGEGENERATESTATUS(state, status) {
      state.generateStatus = status;
    },
    GOGENERATION(state, status) {
      state.goGeneration = status;
    },
    // 展示一类户型
    CHANGETYPE1STATUS(state, status) {
      state.type1Status = status;
    },
    // 展示二类户型
    CHANGETYPE2STATUS(state, status) {
      state.type2Status = status;
    },
    // 展示非标户型
    CHANGENOSTANDSTATUS(state, status) {
      state.noStandStatus = status;
    },
    CHANGESTATICS(state, statics) {
      state.sumStatics = statics;
    },
    CHANGECONSTRUCTSCENTER(state, center) {
      state.constructsCenter = center;
    }
  },
  actions: {
    //获取文件名
    getFileName(context, fileName) {
      context.commit("GETFILENAME", fileName);
    },
    getDataModel(context, dataModel) {
      console.log("data model has been update.");
      context.commit("GETDATAMODEL", dataModel);
    },
    // 获取文件图层名
    getFileLayers(context, layers) {
      context.commit("GETFILELAYER", layers);
    },
    //
    changeGenerationStatus(context, status) {
      context.commit("CHANGEGENERATESTATUS", status);
    },
    // 去生成模型
    goForGeneration(context, status) {
      context.commit("GOGENERATION", status);
    },
    // 展示一类户型
    changeType1Status(context, status) {
      context.commit("CHANGETYPE1STATUS", status);
    },
    // 展示二类户型
    changeType2Status(context, status) {
      context.commit("CHANGETYPE2STATUS", status);
    },
    // 展示非标户型
    changeNoStandStatus(context, status) {
      context.commit("CHANGENOSTANDSTATUS", status);
    },
    changeSumStatics(context, statics) {
      context.commit("CHANGESTATICS", statics);
    },
    changeConstructsCenter(context, center) {
      context.commit("CHANGECONSTRUCTSCENTER", center);
    }
  },
  modules: {}
});
